import { PropTypes } from 'prop-types';
import React, { useState } from 'react';
import Cropper from 'react-easy-crop';
import { faArrowsAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Slider from '@atoms/Slider';
import { SmallInstructions } from '@styled';

const ImageEditor = ({ imageSrc, minPixels = 200, containerHeight = 300, containerWidth = 300, onCropComplete }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [aspect, setAspect] = useState(1);
    const [editDisabled, setEditDisabled] = useState(false);
    const [naturalHeight, setNaturalHeight] = useState();

    const handleZoom = newZoom => {
        const newHeight = naturalHeight / newZoom;
        if (editDisabled || newHeight <= minPixels) return;
        setZoom(newZoom);
    };

    const handleCropChange = newCrop => {
        if (editDisabled) return;
        setCrop(newCrop);
    };

    const handleCropComplete = (croppedArea, croppedAreaPixelsOnComplete) => {
        onCropComplete(croppedArea, croppedAreaPixelsOnComplete);
    };

    return (
        <>
            <div style={{ position: 'relative', height: `${containerHeight}px`, width: `${containerWidth}px` }}>
                <div
                    style={{
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        height: `${containerHeight}px`,
                        border: `1px solid #e4eaee`,
                    }}
                >
                    <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        aspect={aspect}
                        cropShape="round"
                        showGrid={false}
                        onCropChange={handleCropChange}
                        onCropComplete={handleCropComplete}
                        onZoomChange={handleZoom}
                        onMediaLoaded={mediaSize => {
                            setNaturalHeight(mediaSize.naturalHeight);
                            setZoom(1);

                            if (mediaSize.naturalHeight <= minPixels || mediaSize.naturalWidth <= minPixels) {
                                setEditDisabled(true);
                            } else {
                                setEditDisabled(false);
                            }
                        }}
                    />
                </div>
            </div>
            <div className="controls" style={{ width: `${containerWidth}px` }}>
                {editDisabled && (
                    <SmallInstructions style={{ marginTop: '.8rem' }}>Image too small to edit.</SmallInstructions>
                )}
                {!editDisabled && (
                    <>
                        <SmallInstructions style={{ marginTop: '.8rem' }}>
                            <FontAwesomeIcon style={{ marginRight: '5px' }} icon={faArrowsAlt} size="sm" />
                            Drag Photo to Reposition
                        </SmallInstructions>
                        <SmallInstructions style={{ marginBottom: '1rem' }}>
                            {' '}
                            <FontAwesomeIcon icon={faSearch} size="sm" /> Use Slider to Zoom
                        </SmallInstructions>
                        <Slider
                            value={zoom}
                            min={1}
                            max={3}
                            step={0.05}
                            aria-labelledby="Zoom"
                            onChange={handleZoom}
                            disabled={editDisabled}
                        />
                    </>
                )}
            </div>
        </>
    );
};

ImageEditor.propTypes = {
    containerHeight: PropTypes.number,
    containerWidth: PropTypes.number,
    minPixels: PropTypes.number,
    imageSrc: PropTypes.string,
    onCropComplete: PropTypes.func,
};

export default ImageEditor;
